import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            customerId: 'auth/customerId',
        }),
    },
};
